<template>
  <nav class="navbar navbar-expand-xl navbar-dark bg-topbar py-0 d-flex">

    <!-- BOTON MENU MOVIL -->
    <button class="navbar-toggler mr-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <div class="d-flex align-items-center">
        <span class="navbar-toggler-icon d-felx"></span>
      </div>
    </button>
    <!-- FIN BOTON MENU MOVIL -->

    <!-- LOGO -->
    <a class="navbar-brand d-inline-block" href="javascript:void(0)">
      <img :src="logoClaro"/> 
    </a>
    <span class="text-light d-none d-xl-inline">{{ telefonoCorreduria }}</span>
    <!-- FIN LOGO -->
    

    <!-- DROPDOWN USUARIO -->
    <span href="javascript:void(0)" class="my-0 py-0 ml-auto d-flex">
      <div class="nombre-cliente text-light d-none d-md-block small">{{ credentials.nombre|truncate30 }}</div>
      <avisos-top-bar />
      <usuario-top-bar />
    </span>
    <!-- FIN DROPDOWN USUARIO -->

  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import AvisosTopBar from '@/components/avisos/AvisosTopBar'
import UsuarioTopBar from '@/components/usuario/UsuarioTopBar'
export default {
  name: 'top-bar',
  data() {
    return {
      dropdownOpen: false,
      dropDownAvisosOpen: false
    }
  },
  computed: {
    ...mapGetters({
      telefonoCorreduria: 'telefonoCorreduria',
      logoClaro: 'logoClaro',
      credentials: 'credentials',
      avisosNuevos: 'avisosNuevos'
    })
  },
  methods: {
    toggleAvatarDropdown() {
      this.dropdownOpen = !this.dropdownOpen
    },
    toggleAvisosDropdown() {
      this.dropDownAvisosOpen = !this.dropDownAvisosOpen
    }
  },
  components: {
    AvisosTopBar,
    UsuarioTopBar
  }
}
</script>

<style lang="scss" scoped>
.nombre-cliente {
  line-height: 44px;
}
.navbar-brand img {
  height: 35px;
  margin-top: -1px;
}
.logo-cuadrado {
  height: 30px;
  margin-top: -1px;
}
.avatar {
  padding: 5px;
  display: inline-block;
  width: 30px;
  height: 30px;
  border: 2px solid;
  border-radius: 15px;
}
.avatar-name {
  line-height: 30px;
  vertical-align: middle;
  padding-left: 8px;
}
.avatar-dropdown-wrapper {
  cursor: pointer;
}
.avatar-dropdown-menu {
  position: absolute;
  top: 53px;
  right: 0;
  width: 250px;
  z-index: 1080;
}
.avatar-dropdown-menu a:hover {
  background-color: rgba(0, 0, 0, 0.096);
  background-blend-mode: screen;
  text-decoration: none;
}
.navbar {
  z-index: 1001;
}

@media (max-width: 768px) {
  .avatar-dropdown-menu {
    top: 48px;
  }
}
</style>

